<template>
  <div :class="$style['adl-expandable-menu']">
    <template v-for="section in sections">
      <mds-section border="none" :size="8" :bold="true" :title="section.name">
        <adl-menu
          :sectionId="section.id"
          :class="$style['sections']"
          :menus="menus"
          :subMenus="subMenus"
          @onClick="onClick"
        ></adl-menu>
      </mds-section>
    </template>
  </div>
</template>
<script>
import { MdsListGroup, MdsListGroupItem } from "@mds/list-group";
import MdsSection from "@mds/section";
import AdlMenu from "./menu.vue";
export default {
  inheritAttrs: false,

  props: {
    sections: {
      type: Array,
    },
    menus: {
      type: Array,
    },
    subMenus: {
      type: Array,
    },
  },
  components: {
    MdsSection,
    MdsListGroupItem,
    MdsListGroup,
    AdlMenu,
  },

  data() {
    return {
      isFocus: false,
      refreshKey: 0,
      showButton: false,
    };
  },
  computed: {},

  async created() {},
  methods: {
    onClick(sectionId, menuId, submenuId) {
      this.$emit("onClick", sectionId, menuId, submenuId);
    },
  },
};
</script>
<style lang="scss" module>
@import "@mds/constants";
@import "@mds/typography";
.adl-expandable-menu {
  .sections {
    margin-bottom: $mds-space-3-x;
  }
}
</style>
